import { fetchAttachments } from 'api/file'
import axios from 'axios'
import classnames from 'classnames'
import useThemeColors from 'hooks/useThemeColors'
import { receiveAttachments } from 'modules/conversations/actions'
import React, { useEffect, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { MessageSenderType } from 'types/message'

import FileAttachment from './file'
import ImageAttachment from './image'

import './style.css'

type AttachmentMessageProps = {
  attachmentIds: number[],
  resolveMessageHeight: () => void,
  sentFrom: MessageSenderType
}

const AttachmentMessage = ({
  attachmentIds = [],
  resolveMessageHeight,
  sentFrom = MessageSenderType.END_USER
}: AttachmentMessageProps) => {
  const dispatch = useDispatch()
  const attachments = useSelector(state => state.conversations.attachments)
  const cancelToken = axios.CancelToken.source()

  const { agentMessageTheme, endUserMessageTheme } = useThemeColors()

  const attachmentTheme = sentFrom === MessageSenderType.END_USER
    ? endUserMessageTheme
    : agentMessageTheme

  useEffect(() => {
    const attachmentsToBeFetched = attachmentIds.filter(id => !attachments[id])

    const fetchAttachmentsForMessage = async () => {
      try {
        const { data } = await fetchAttachments(attachmentsToBeFetched, cancelToken.token)
        dispatch(receiveAttachments({ attachments: data }))
      } catch(err) { }
    }

    attachmentsToBeFetched.length && fetchAttachmentsForMessage()

    return () => {
      cancelToken.cancel()
    }
  }, [attachments, attachmentIds, cancelToken, dispatch])

  const isImage = ({ mimeType }) => {
    return /image/.test(mimeType) && mimeType !== 'image/svg+xml'
  }

  const attachmentComponents = useMemo(() => {
    return (
      attachmentIds && attachmentIds.map((id) => {
        if(!attachments[id]) {return null}

        return (
          isImage(attachments[id])
            ? <ImageAttachment attachment={attachments[id]} key={`drift-widget-attachment--${id}`} resolveMessageHeight={resolveMessageHeight}/>
            : <FileAttachment multi={attachmentIds.length > 1} attachment={attachments[id]} key={`drift-widget-attachment--${id}`} senderType={sentFrom} />
      )})
    )
  }, [attachmentIds, attachments, resolveMessageHeight, sentFrom])


  return (
    <div
      style={attachmentTheme}
      className={classnames("drift-widget-attachment drift-widget-message--box",{
        "drift-widget-attachment--multi": attachmentIds && attachmentIds.length > 1
      })}
    >
      {attachmentComponents}
    </div>
  )
}


export default AttachmentMessage
